export const ENDPOINT = `https://minecraft.vladpoienariu.com/api`
